import { useState, useRef, useEffect } from 'react';
import "./MultiSelectDropdownWithCount.scss";

import checkedIocn from "../../../images/check_white_icon.svg";
import customClearIcon from "../../../images/Close_Blue_Icon.svg";
import uncheckedIocn from "../../../images/uncheckedbox.svg";
import ExpandIcon from "../../../images/ExpandIcon.svg";
import CollapseIcon from "../../../images/CollapseIcon.svg";

export default function MultiSelectDropdownWithCount({
  options = [],
  label = "Indication",
  onChange,
  placeholderText = "Search & Select",
  setSelected,
  selected,
  labelKey = "name",
  valueKey = "_id"
}) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setOpen(false);
        setSearch('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleOption = (option) => {
    setSelected((prev) => {
      const exists = prev.find(
        (item) => item[valueKey] === option[valueKey]
      );

      let updated;

      if (exists) {
        updated = prev.filter(
          (item) => item[valueKey] !== option[valueKey]
        );
      } else {
        updated = [...prev, option];
      }

      onChange && onChange(updated);
      return updated;
    });
  };

  const clearAll = (e) => {
    e.stopPropagation();
    setSelected([]);
    onChange && onChange([]);
  };

  const filteredOptions = options?.filter((opt) =>
    opt?.[labelKey]
      ?.toLowerCase()
      .includes(search?.toLowerCase())
  );

  const isFloating = open || selected.length > 0;

  return (
    <div ref={containerRef} className="multi-select-dropdown">
      
      {/* MAIN BOX */}
      <div
        onClick={() => setOpen((prev) => !prev)}
        className='multi-select__control'
      >
        {/* LABEL */}
        <div
          className={`multi-select__label ${
            isFloating ? 'floating' : ''
          }`}
          style={{
            position: 'absolute',
            left: 12,
            top: isFloating ? 4 : '50%',
            transform: isFloating ? 'none' : 'translateY(-50%)',
            fontSize: isFloating ? 10 : 12,
            color: isFloating ? '#54565B': '#1E1E1E',
            transition: 'all 0.2s ease',
            pointerEvents: 'none',
            fontWeight: 400,
            fontFamily: 'Nunito Sans'
          }}
        >
          {label}
        </div>

        {/* INPUT / VALUE */}
        <div className="multi-select__value">
          {open ? (
            <input
              autoFocus
              className="multi-select__input"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onClick={(e) => e.stopPropagation()}
              placeholder={placeholderText}
            />
          ) : (
            <div
              className="multi-select__text"
            >
              {selected.length === 0
                ? ''
                : selected[0][labelKey]}
            </div>
          )}
        </div>

        {/* RIGHT SIDE */}
        <div className="multi-select__actions">
          {selected.length > 0 && (
            <>
              {selected.length > 1 && (
                <span
                  className="multi-select__count"
                >
                  +{selected.length - 1}
                </span>
              )}

              {/* CLEAR ICON */}
              <span
                className="multi-select__clear"
                onClick={clearAll}
              >
                <img
                  src={customClearIcon}
                  alt="clear"
                  width={12}
                  height={12}
                />
              </span>
            </>
          )}

          <span style={{ fontSize: 12 }} className="multi-select__arrow">
            <img src={open ? CollapseIcon : ExpandIcon} alt=''/>
          </span>
        </div>
      </div>

      {/* DROPDOWN */}
      {open && (
        <div
          className="multi-select__dropdown"
        >
          {filteredOptions.map((option) => {
            const isChecked = selected.some(
              (item) => item[valueKey] === option[valueKey]
            );

            return (
              <div
                key={option[valueKey]}
                className={`multi-select__option ${
                  isChecked ? 'selected' : ''
                }`}
                onClick={() => toggleOption(option)}
              >
                {/* CHECKBOX ICON */}
                <img
                  className={`multi-select__checkbox ${
                    isChecked ? 'checked' : 'unchecked'
                  }`}
                  src={isChecked ? checkedIocn : uncheckedIocn}
                  alt="checkbox"
                />

                <span 
                  className="multi-select__option-text"
                >{option[labelKey]}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// export default function MultiSelectDropdownWithCount({
//   options = [],
//   label = "Select",
//   onChange,
//   placeholderText = "Search & Select",
//   dropdownIcon,
//   setSelected,
//   selected
// }) {
//   const [open, setOpen] = useState(false);
//   const [focused, setFocused] = useState(false);
//   const inputRef = useRef(null);

//   const handleChange = (event, newValue) => {
//     setSelected(newValue);
//     if (onChange) onChange(newValue); // Notify parent
//   };

//   const customIcon = (
//     <img
//       src={uncheckedIocn}
//       alt="unchecked"
//       style={{ width: 12, height: 12 }}
//     />
//   );

//    const customClearData = (
//     <img
//       src={customClearIcon}
//       alt="unchecked"
//       style={{ width: 12, height: 12 }}
//     />
//   );

//   const customCheckedIcon = (
//     <img
//       src={checkedIocn}
//       alt="checked"
//       style={{ width: 12, height: 12, background: "#203662", padding: "2px" }}
//     />
//   );

//   console.log(open)
//   return (
//     <Autocomplete
//       multiple
//       open={open}
//       onClick={(prev) => !prev}
//       className={`custom-multi-Select-Dropdown-with-count ${
//         open ? "open-custom-multi-Select-Dropdown" : ""
//       } ${!open && selected.length > 0 ? "custom-closed-dropdown" : ""}`}
//       onOpen={() => setOpen(true)}
//       onClose={(event, reason) => {
//         setOpen(false);
//         console.log(inputRef.current.blur())
//         if (inputRef.current) {
//           inputRef.current.blur(); // remove focus
//         }
//       }}
//       options={options}
//       value={selected}
//       disableCloseOnSelect
//       disableClearable={selected.length === 0}
//       ListboxProps={{
//         className: "custom-dropdown-list",
//       }}
//       clearIcon={customClearData}
//       id="combo-box-demo-selectbox-"
//       onChange={handleChange}
//       sx={{
//         "& .MuiOutlinedInput-root": {
//           height: "42px",
//           minHeight: "42px",
//           padding: "0 8px",
//           display: "flex",
//           alignItems: "center",
//         },
//         "& .MuiAutocomplete-inputRoot": {
//           flexWrap: "nowrap !important",
//         },
//         "& .MuiAutocomplete-input": {
//           padding: "0 !important",
//         },
//         "& .MuiInputBase-input": {
//           fontSize: "12px",
//         },
//         "& .MuiAutocomplete-clearIndicator": {
//           visibility: selected.length > 0 ? "visible" : "hidden",
//           opacity: selected.length > 0 ? 1 : 0,
//         },
//         "&:hover .MuiAutocomplete-clearIndicator": {
//           visibility: selected.length > 0 ? "visible" : "hidden",
//           opacity: selected.length > 0 ? 1 : 0,
//         },
//   //        "& .MuiOutlinedInput-root": {
//   //   height: 42,
//   //   minHeight: 42,
//   //   display: "flex",
//   //   alignItems: "flex-start", // move text to top
//   // },
//   // "& .MuiOutlinedInput-input": {
//   //   padding: "10px 0 0 10px", // top 10px, left 10px
//   //   minWidth: "196px",
//   // },
//   // "& .MuiAutocomplete-input": {
//   //   padding: "10px 0 0 10px !important", // override MUI default
//   // },
//         // "& .MuiAutocomplete-option": {
//         //   fontSize: "12px",
//         // },
//       }}
//       getOptionLabel={(option) => option.name}
//       isOptionEqualToValue={(option, value) => option._id === value._id}
//       popupIcon={dropdownIcon || undefined}
//       renderOption={(props, option, { selected }) => (
//         <li {...props}>
//           <Checkbox
//             icon={customIcon}
//             checkedIcon={customCheckedIcon}
//             checked={selected}
//             sx={{ mr: 1 }}
//           />
//           {option.name}
//         </li>
//       )}
//       renderTags={(value) => {
//         if (value.length === 0) return null;
//         if (open) return null;
//         return value[0].name;
//       }}
//       renderInput={(params) => {
//         const { InputProps } = params;

//         return (
//           <TextField
//             // focused={open ? true : false}
//             {...params}
//             label={label}
//             inputRef={inputRef}
//             placeholder={focused || open ? (selected.length > 0 && !open ) ? "" : placeholderText : ""}
//             onFocus={() => setFocused(true)}
//             // onBlur={() => setFocused(false)}
//             onBlur={() => setOpen(false)}
//             InputProps={{
//               ...InputProps,
//               endAdornment: (
//                 <>
//                   {selected.length > 1 && (
//                     <span
//                       style={{
//                         marginRight: -15,
//                         marginBottom: 16,
//                         fontSize: 10,
//                         fontFamily: "Nunito Sans",
//                         fontWeight: 700,
//                         whiteSpace: "nowrap",
//                         color: "#203662",
//                         width: 20,
//                         height: 16,
//                         borderRadius: 16,
//                         background: "#F0F5F8",
//                         display: "flex",
//                         justifyContent: "center",
//                         alignItems: "center"
//                       }}
//                     >
//                       +{selected.length - 1}
//                     </span>
//                   )}
//                   {InputProps.endAdornment}
//                 </>
//               ),
//             }}
//             sx={{
//               "& .MuiOutlinedInput-root": {
//                 height: 42,
//                 minHeight: 42,
//               },
//               // "& .MuiOutlinedInput-input": {
//               //   padding: "10px 14px",
//               //   minWidth: 0
//               // },
//             }}
//           />
//         );
//       }}
//     />
//   );
// }
